module.exports = __webpack_public_path__ + "img/icon_play.ba568bf9.svg";